module.exports = __webpack_public_path__ + "img/4.fafebcc9.png";